import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { LOGO_URL } from "../lib/brand";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      if (!sid) { navigate("/login"); return; }
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        setUser(data.user || data);
        window.history.replaceState(null, "", "/");
        navigate(data.user?.onboarded ? "/" : "/onboarding");
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center aurora">
      <img src={LOGO_URL} alt="Agro Madat" className="h-16 w-16 rounded-2xl object-contain bg-white shadow-md mb-4 animate-pulse" />
      <Loader2 className="h-5 w-5 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground mt-3">Signing you in…</p>
    </div>
  );
}
